import { useQuery } from '@tanstack/react-query';
import { mockSuggestions, Suggestion } from '@mocks/suggestions';
import { queryKeys } from '../queryKeys';

// Mock API call
const fetchSuggestions = async (): Promise<Suggestion[]> =>
  new Promise(resolve => {
    setTimeout(() => resolve(mockSuggestions), 450);
  });

export const useSuggestions = () =>
  useQuery({
    queryKey: queryKeys.suggestions,
    queryFn: fetchSuggestions,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
